<div *ngIf="isLoading">Loading Credit List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="credit" [(ngModel)]="model.credit" [required]="required">
  <option *ngFor="let singleCredit of credits" [ngValue]="singleCredit">{{ singleCredit.name }}</option>
</select>
